import React from "react";
import CommonDocumentModuleInterface from "@/pages/T4/CommonDocumentModuleInterface";
interface ViewOnboardingDocumentsTimelineProps {}

const ViewOnboardingDocumentsTimeline: React.FC<
  ViewOnboardingDocumentsTimelineProps
> = () => {
  return (
    <>
      <CommonDocumentModuleInterface isView={true} isTimeline={true} />
    </>
  );
};

export default ViewOnboardingDocumentsTimeline;
